import {client} from '@/utils/gql'
import {ProfileFragment, User_Profile_Bool_Exp, User_Profile_Set_Input} from '@/utils/graphqlSdk'
import {NotFoundError, ServerError} from '@/utils/server/errors'

export const insertOne = async (userId: string, profileData?: User_Profile_Set_Input) => {
  await client.userProfileInsertOne({object: {...profileData, user_id: userId}})
}

const getOneOrNull = async (filter: User_Profile_Bool_Exp): Promise<ProfileFragment | null> => {
  const profile = (await client.userProfileGetMany({filter})).user_profile

  if (profile.length > 1) {
    throw new ServerError('Get one returned multiple results', {filter})
  }

  return profile?.[0] ?? null
}

const getOne = async (filter: User_Profile_Bool_Exp): Promise<ProfileFragment> => {
  const profile = await getOneOrNull(filter)

  if (!profile) {
    throw new NotFoundError('Get one returned null', {filter})
  }

  return profile
}

const updateOne = async (id: number, changes: User_Profile_Set_Input): Promise<ProfileFragment> => {
  const result = (await client.userProfileUpdateOne({id, changes}))?.update_user_profile_by_pk

  if (!result) {
    throw new ServerError('User profile not returned after update', {id, changes})
  }

  return result
}

export const userProfileOrm = {
  getOne,
  getOneOrNull,
  updateOne,
  insertOne,
}
